import { useTranslation } from 'react-i18next';
import ErrorPageTempate from './ErrorPageTempate';

function Error500() {
  const { t } = useTranslation();

  return (
    <ErrorPageTempate
      label={t('Internal Server Error.')}
      code={500}
    />
  );
}

export default Error500;
